"use client";

import useSWR from "swr";
import CustomContent from "../components/customContent";
import styles from "../layout.module.css";
import { getPage } from "../sanity/client";

export default function Donate() {
  const { data: content } = useSWR("page-donate", () =>
    getPage("donate").then((r) => r[0].content)
  );

  return (
    <>
      <h1>Donate</h1>

      <a
        className={styles.donateButton}
        target="_blank"
        rel="noreferrer"
        href="https://www.zeffy.com/en-US/donation-form/scribbles-2026-fundraising-drive"
      >
        Donate to Scribble
      </a>

      <CustomContent value={content} />
    </>
  );
}
